import { render, staticRenderFns } from "./insider.vue?vue&type=template&id=118af732&"
import script from "./insider.vue?vue&type=script&lang=js&"
export * from "./insider.vue?vue&type=script&lang=js&"
import style0 from "./insider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports